import { DEFAULT_BRANCH_INDEX, getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import { getEdgeIdForAction } from 'automation-ui-canvas/utils/getEdgeIdForAction';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { registerQuery, useQuery } from 'data-fetching-client';
import cloneDeep from 'hs-lodash/cloneDeep';
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
// A function to add values for empty branches
const fillInEnrollmentConversionBranchData = (flow, enrollmentConversionData) => {
  const {
    actions
  } = flow;
  const enrollmentConversionDataFilled = cloneDeep(enrollmentConversionData);
  actions.forEach(action => {
    if (action.isBranch()) {
      var _enrollmentConversion;
      const branchConversionData = (_enrollmentConversion = enrollmentConversionData.conversionReport.sourceDestinationMap[action.getActionId()]) !== null && _enrollmentConversion !== void 0 ? _enrollmentConversion : {};
      const connection = action.getConnection();
      if (action.isListBranch() || action.isStaticBranch()) {
        const defaultConnection = connection.getDefaultConnector();
        if (!defaultConnection) {
          var _enrollmentConversion2, _enrollmentConversion3;
          const edgeId = getEdgeIdForAction(action.getActionId(), DEFAULT_BRANCH_INDEX);
          const prevActionId = getPreviousActionId(edgeId);
          const passThroughCount = (_enrollmentConversion2 = (_enrollmentConversion3 = enrollmentConversionData.conversionReport.actionStatusCounts[prevActionId]) === null || _enrollmentConversion3 === void 0 ? void 0 : _enrollmentConversion3.workflowCompleted) !== null && _enrollmentConversion2 !== void 0 ? _enrollmentConversion2 : 0;
          branchConversionData[`end-${DEFAULT_BRANCH_INDEX}`] = passThroughCount;
        }
      }
      const branches = connection.getBranches();
      branches.forEach((branch, index) => {
        const connector = branch.getConnector();
        if (!connector) {
          const edgeId = getEdgeIdForAction(action.getActionId(), index);
          const prevActionId = getPreviousActionId(edgeId);
          const actionStatusCounts = enrollmentConversionData.conversionReport.actionStatusCounts[prevActionId];
          const passThroughCount = actionStatusCounts ? actionStatusCounts.workflowCompleted : 0;
          branchConversionData[`end-${index}`] = passThroughCount;
        }
      });
      enrollmentConversionDataFilled.conversionReport.sourceDestinationMap[action.getActionId()] = branchConversionData;
    }
  });
  return enrollmentConversionDataFilled;
};
export const FETCH_ENROLLMENT_CONVERSION_DETAILS = registerQuery({
  fieldName: 'fetchEnrollmentConversionDetails',
  args: ['flow', 'startTimestamp', 'endTimestamp'],
  fetcher({
    flow,
    startTimestamp,
    endTimestamp
  }) {
    const {
      flowId
    } = flow;
    return http.post('automationreporting/v1/conversion/aggregate-report', {
      data: {
        flowId,
        startTimestamp,
        endTimestamp
      }
    }).then(data => fillInEnrollmentConversionBranchData(flow, data));
  }
});
export const wireGetEnrollmentConversionDetails = WrappedComponent => props => {
  const {
    flow
  } = props;
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  const {
    data: aggregateData
  } = useQuery(FETCH_ENROLLMENT_CONVERSION_DETAILS, {
    variables: {
      flow,
      startTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp,
      endTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.endTimestamp
    },
    skip: !timeStamps || !(timeStamps !== null && timeStamps !== void 0 && timeStamps.startTimestamp) || !(timeStamps !== null && timeStamps !== void 0 && timeStamps.endTimestamp) || (timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.endTimestamp) < (timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp)
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    enrollmentConversionData: aggregateData === null || aggregateData === void 0 ? void 0 : aggregateData.fetchEnrollmentConversionDetails
  }));
};